import React from 'react';

import i18n from '../../i18n';
import BalancesEditor from './components/BalancesEditor';

export default class DialogBalanceField extends React.Component {
    render() {
        // field, value, onChange
        let value = this.props.value;
        let translatedName = i18n.t(`columns.${this.props.field.label}`);
        let defaultBalances = {};
        if (
            (!value || Object.keys(value).length === 0) &&
            this.props.field.defaultCurrencies &&
            Array.isArray(this.props.field.defaultCurrencies)
        ) {

            this.props.field.defaultCurrencies.forEach((currency) => {
                defaultBalances[currency] = 0;
            });
        }
        return (
            <BalancesEditor
                balances={value || defaultBalances}
                label={translatedName}
                onChange={(newVal) =>
                    this.props.onChange(this.props.field.id, newVal)
                }
                readOnly={!!this.props.field.onlyRead}
            />
        );
    }
}
